import { cn } from '@/lib/utils';

function SkeletonList({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('flex w-full flex-col items-start gap-2.5 p-2.5', className)} {...props}>
      {[...Array(3)].map((_, i) => (
        <div key={i} className="flex h-[112px] w-full flex-row items-start gap-4 rounded-md bg-white px-4 py-6">
          <div className="bg-grey-2 h-9 w-9 rounded-[36px]"></div>
          <div className="flex h-[52px] w-[200px] flex-col items-start gap-4 p-0">
            <div className="bg-grey-2 h-4 w-[200px] rounded"></div>
            <div className="bg-grey-2 h-4 w-[100px] rounded"></div>
          </div>
        </div>
      ))}
    </div>
  );
}

export { SkeletonList };
